/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html} from 'lit';
import styles from './no-results.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class NoResults extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			message: {
				type: String
			}
		};
	}

	constructor () {
		super();
	}

	render () {
		return html`
			<div class="no-results">
				<h2 class="no-results--title">No Results</h2>
				<div class="no-results--message">${this.message}</div>
				<rb-chat-widget hide-trigger>
					<button slot="trigger" class="no-results--expert">Talk to an Expert</button>
				</rb-chat-widget>
			</div>
		`;
	}
};

defineCustomElement('rb-no-results', NoResults);
